import { h } from 'preact'
import { useState, useEffect, useRef } from 'preact/hooks'
import { attributesAnalytics } from '../../js/modules/component'

const VIDEO = {
   url: 'https://storage.googleapis.com/ofr-0a7-data-hporange-22988-prd/habillage-test/Composition%205_13.mp4',
   url_mobile: 'https://storage.googleapis.com/ofr-0a7-data-hporange-22988-prd/habillage-test/Composition%206_1.mp4',
}

export const HabillageFond = ({ backgroundImage = '', image = '', alt, URL, analytics, cacheKey, display = true, video = VIDEO }) => {
   const [isVisible, setIsVisible] = useState(display)
   const [videoSource, setVideoSource] = useState(video ? (window.innerWidth > 480 ? video?.url : video?.url_mobile) : '')
   const videoRef = useRef(null)

   useEffect(() => {
      const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth
      document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)

      const handleSG1event = (event) => {
         setIsVisible(event.detail.display)
      }

      window.addEventListener('SG1event-habillage', handleSG1event)

      // Supprimer le scroll horizontal causé par la video
      document.body.style = 'overflow-x: hidden;'

      // Page resize
      const handleResize = () => {
         if (!video) return
         setVideoSource(window.innerWidth > 480 ? video?.url : video?.url_mobile)
         videoRef.current?.load() // Reload the video with the new source
      }
      window.addEventListener('resize', handleResize)

      return () => {
         window.removeEventListener('SG1event-habillage', handleSG1event)
      }
   }, [])

   return (
      <div class={`habillage-fond${!image ? ' no-front-image' : ''}`} key={cacheKey} style={{ display: isVisible ? 'block' : 'none' }}>
         <div class="background-image">
            <img src={backgroundImage} class="background-main-image" alt={alt} />
         </div>
         <div class="front-image" style={{ backgroundImage: `url(${image})` }}></div>
         {video !== '' && (
            <div class="front-video">
               <video
                  ref={videoRef}
                  aria-label=""
                  autoplay="autoplay"
                  muted
                  preload="auto"
                  tabIndex="-1"
                  playsinline // mobile: evite le fullscreen
               >
                  <source src={videoSource} type="video/mp4" />
               </video>
            </div>
         )}
         <div class="mask-blur"></div>
         <a class="banner-link" href={URL} {...attributesAnalytics(analytics)}></a>
      </div>
   )
}
